// API configuration for the RackStar application
// This file centralizes API endpoints for easier management

import logger from "../helpers/logger";

// Determine the API base URL based on environment
let apiBaseUrl;

// Environment-specific API configurations
const apiConfigs = {
  Dev: {
    baseUrl: "https://rackstar-dev-as-api.azurewebsites.net"
  },
  Test: {
    baseUrl: "https://rackstar-test-as-api.azurewebsites.net"
  },
  Prod: {
    baseUrl: "https://rackstar-prod-as-api.azurewebsites.net"
  }
};

// Determine environment from VITE_ENVIRONMENT (defaults to Dev)
const environment = import.meta.env.VITE_ENVIRONMENT || "Dev";
const apiConfig = apiConfigs[environment] || apiConfigs.Dev;

// Use environment variable if set, otherwise use environment-specific configuration
apiBaseUrl =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  apiConfig.baseUrl;

logger.log(`API Environment: ${environment}`);
logger.log(`API Base URL: ${apiBaseUrl}`);

// Export the base URL
export const API_BASE_URL = apiBaseUrl;

// Export specific API endpoints as needed
export const ENDPOINTS = {
  OPENAI_CHAT: "openai/chat",
  RACK_STAR: "rackstar",
  // Add more endpoints as needed
};

// Export any API-related utility functions
export const addAuthHeader = (headers = {}) => {
  // You can add auth token logic here if needed
  return headers;
};